import {useMemo} from 'react'
import OrderEditProductsWrapper from './OrderEditProductsWrapper'
import OrderEditWrapper from './OrderEditWrapper'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import {selectIsProductsEditMode} from 'app/features/orders/redux/order/orderEditSlice'

export const OrderEdit = () => {
  const isProductMode = useSelector<RootState, boolean>(selectIsProductsEditMode)

  return useMemo(() => {
    if (isProductMode) {
      return <OrderEditProductsWrapper />
    }

    return <OrderEditWrapper />
  }, [isProductMode])
}

export default OrderEdit
